import {
  Autocomplete,
  FormControl,
  InputAdornment,
  TextField,
} from "@mui/material";
import { HomeIcon, MapPinIcon, Search } from "lucide-react";
import { Grid } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { EuroOutlined } from "@ant-design/icons";

const propertyTypes = [
  {
    label: "Byt",
    value: "apartment",
  },
  {
    label: "Dom",
    value: "family_house",
  },
  {
    label: "Pozemok",
    value: "land",
  },
];

// const locations = [
//   "Bódvaszilas",
//   "Edelény",
//   "Galvács",
//   "Hejce",
//   "Jósvafő",
//   "Komjáti",
//   "Meszes",
//   "Mártonyi",
//   "Rakaca",
//   "Rudabánya",
//   "Szalonna",
//   "Szendrő",
//   "Szuhogy",
//   "Teresztenye",
//   "Tornaszentandrás",
// ];

// const locationCoordintes = {
//     'Bódvaszilas': {
//         lat: 48.536846,
//         long: 20.731571
//     },
//     'Edelény': {
//         lat: 48.293613,
//         long: 20.734013
//     },
//     'Galvács': {
//         lat: 48.419436,
//         long: 20.77789
//     },
//     'Hejce': {
//         lat: 48.424052,
//         long: 21.280688
//     },
//     'Jósvafő': {
//         lat: 48.482480,
//         long: 20.554047
//     },
//     'Komjáti': {
//         lat: 48.545703,
//         long: 20.760774
//     },
//     'Meszes': {
//         lat: 48.438664,
//         long: 20.796003
//     },
//     'Mártonyi': {
//         lat: 48.472064,
//         long: 20.764832
//     },
//     'Rakaca': {
//         lat: 48.458852,
//         long: 20.883043
//     },
//     'Rudabánya': {
//         lat: 48.373781,
//         long: 20.622451
//     },
//     'Szalonna': {
//         lat: 48.447205,
//         long: 20.739375
//     },
//     'Szendrő': {
//         lat: 48.404591,
//         long: 20.732574
//     },
//     'Szuhogy': {
//         lat: 48.38385,
//         long: 20.673761
//     },
//     'Teresztenye': {
//         lat: 48.446403,
//         long: 20.604776
//     },
//     'Tornaszentandrás': {
//         lat: 48.520264,
//         long: 20.775749
//     }
// }

const Filter = (props: {
  location?: string | null;
  propertyType?: string | null;
  price?: number[] | null;
  listings: any[];
}) => {
  const realLocations = [
    // @ts-ignore
    ...new Set(props.listings?.map((listing: any) => listing.location?.city)),
  ];
  const [location, setLocation] = useState(props.location || undefined);
  const [propertyType, setPropertyType] = useState(
    props.propertyType || undefined
  );
  const [price, setPrice] = useState(props.price || []);
  const navigate = useNavigate();

  const handleSearch = () => {
    console.log("Searching with:", {
      location,
      propertyType,
      price,
    });

    // Build query parameters, only including non-empty values
    const params = new URLSearchParams();

    if (location) {
      params.append("location", location);
    }

    if (propertyType) {
      params.append("propertyType", propertyType);
    }

    if (price && price.length > 0 && (price[0] || price[1])) {
      const priceString = price.join(",");
      if (priceString !== ",") {
        params.append("price", priceString);
      }
    }

    const queryString = params.toString();
    navigate(`/properties${queryString ? `?${queryString}` : ""}`);
  };
  const labelStyle =
    "flex items-center gap-2 text-sm font-bold text-[#1f2937] mb-2";

  //   const handlePriceChange = (event: Event, newValue: number[]) => {
  //     setPrice(newValue);
  //   };

  //   function valuetext(value: number) {
  //     return `${value} €`;
  //   }

  //   const [value, setValue] = useState<number[]>([0, 10000000]);

  //   const getPriceText = (value: number) => {
  //     return `${value} €`;
  //   };

  //   const handleChange = (event: Event, newValue: number[]) => {
  //     console.log("newValue", newValue);
  //     setValue(newValue);
  //   };

  const setFromPrice = (value: number) => {
    setPrice([value, price[1]]);
  };
  const setToPrice = (value: number) => {
    setPrice([price[0], value]);
  };

  // const isMobile = useMediaQuery('(max-width: 768px)');

  const handleLocationChange = (value: string | undefined) => {
    setLocation(value);
  };

  return (
    <Grid
      container
      className={
        "bg-white shadow-md px-5 py-7 flex flex-wrap md:flex-nowrap items-center gap-4 justify-center  "
      }
      spacing={2}
    >
      {/* Filter: Lokalita */}
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <div className={labelStyle + " pb-1"}>
            <MapPinIcon className="w-5 h-5 text-[#9b8b4b] mr-3" />
            Lokalita
          </div>
          <Autocomplete
            disablePortal
            options={realLocations}
            defaultValue={location}
            sx={{
              width: "100%",
              borderColor: "#9b8b4b",
              borderRadius: "5px",
              color: "#000",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9b8b4b",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "darkred",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9b8b4b",
              },
              "& .MuiSelect-select": {
                paddingTop: "8px",
                paddingBottom: "8px",
                display: "flex",
                alignItems: "center",
              },
              padding: "0",
            }}
            onChange={(e, value) => {
              //   if (value) {
              handleLocationChange(value ?? undefined);
              //   }
            }}
            renderInput={(params) => (
              <TextField
                style={{ padding: "0" }}
                {...params}
                label="Vyberte lokalitu"
              />
            )}
            getOptionLabel={(option) =>
              option +
              (props.listings
                ? ` (${
                    props.listings.filter(
                      (l: any) => l.location?.city === option
                    ).length
                  })`
                : "")
            }
          />
        </div>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <div className={labelStyle + " pb-1"}>
            <HomeIcon className="w-5 h-5 text-[#9b8b4b] mr-3" />
            Nehnuteľnosť
          </div>
          <Autocomplete
            disablePortal
            options={propertyTypes}
            getOptionLabel={(option) => option.label}
            defaultValue={propertyTypes.find((pt) => pt.value === propertyType)}
            sx={{
              width: "100%",
              borderColor: "#9b8b4b",
              borderRadius: "5px",
              color: "#000",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9b8b4b",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "darkred",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9b8b4b",
              },
              "& .MuiSelect-select": {
                paddingTop: "8px",
                paddingBottom: "8px",
                display: "flex",
                alignItems: "center",
              },
              padding: "0",
            }}
            onChange={(e, value) => {
              setPropertyType(value?.value);
            }}
            renderInput={(params) => (
              <TextField
                style={{ padding: "0" }}
                {...params}
                label="Vyberte typ nehnuteľnosti"
              />
            )}
          />
        </div>
      </Grid>

      {/* Range Inputs: Od / Do */}
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <div className={labelStyle}>
            <EuroOutlined
              className=" text-[#9b8b4b]"
              style={{ fontSize: "1.2rem" }}
            />
            Cena
          </div>

          <div className="flex flex-row gap-2 w-full">
            {["Od", "Do"].map((label, index) => (
              <FormControl
                fullWidth
                size="small"
                key={label}
                sx={{
                  width: "100%",
                }}
              >
                <TextField
                  label={label}
                  variant="outlined"
                  fullWidth
                  value={price[index]}
                  onChange={(e) => {
                    console.log("e.target.value", e.target.value);
                    console.log(
                      "Number(e.target.value))",
                      Number(e.target.value)
                    );

                    if (index === 0) {
                      if (isNaN(Number(e.target.value))) {
                        setFromPrice(0);
                      } else {
                        setFromPrice(Number(e.target.value));
                      }
                    }
                    if (index === 1) {
                      if (isNaN(Number(e.target.value))) {
                        setToPrice(10000000);
                      } else {
                        setToPrice(Number(e.target.value));
                      }
                    }
                  }}
                  InputProps={{
                    endAdornment:
                      price[index] !== undefined ? (
                        <InputAdornment position="end">€</InputAdornment>
                      ) : null,

                    sx: {
                      // height: "2.7rem",
                      borderRadius: "5px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9b8b4b",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "darkred",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9b8b4b",
                      },
                    },
                  }}
                  inputProps={{
                    style: {
                      paddingTop: 10,
                      paddingBottom: 10,
                    },
                  }}
                  InputLabelProps={{
                    sx: { color: "#9b8b4b" },
                  }}
                />
              </FormControl>
            ))}
          </div>
        </div>
      </Grid>

      {/* <div className="flex-grow min-w-[150px]">
                  <div className={labelStyle}>
                      <Euro className="w-5 h-5 text-[#9b8b4b]" />
                      Cena
                  </div> */}

      {/* 
              <div className="relative flex-grow">
                  <div className="flex items-center border border-[#9b8b4b] rounded-lg px-4 py-2 cursor-pointer">
                      <CreditCardIcon className="w-5 h-5 text-[#9b8b4b] mr-3" />
                      <div className="flex flex-col text-sm">
                          <span className="font-bold text-[#1f2937]">Cena</span>
                          <span className="text-gray-500 text-xs">{price}</span>
                      </div>
                      <ChevronDownIcon className="w-4 h-4 text-[#9b8b4b] ml-auto" />
                  </div>
                  <select
                      className="absolute top-full left-0 mt-1 w-full text-sm bg-white border rounded-lg shadow z-10"
                      onChange={(e) => setPrice(e.target.value)}
                  >
                      <option value="Vyberte cenu">Vyberte cenu</option>
                      <option value="Do 100 000 €">Do 100 000 €</option>
                      <option value="100 000 – 200 000 €">100 000 – 200 000 €</option>
                      <option value="Nad 200 000 €">Nad 200 000 €</option>
                  </select>
              </div>
              Filter: Cena */}

      {/* Search Button */}
      <Grid
        size={{ xs: 12, sm: 6, md: 4, lg: 2 }}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end", // Push content to bottom
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="nice-button text-white font-semibold rounded-lg px-6 py-2 flex items-center justify-center w-full"
            onClick={handleSearch}
            style={{
              fontSize: "1.2rem",
              fontWeight: "600",
              marginBottom: "-1.3rem",
            }}
          >
            Vyhľadať
            <Search className="w-5 h-5 ml-2" />
          </button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Filter;
